export default "__VITE_ASSET__C0Rc9OzL__"